import React from "react";
import { getSessionId } from "owa-config";
import { getIsDarkTheme } from "owa-fabric-theme";
import { getCurrentLanguage } from "owa-localize";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { isConsumer, getUserConfiguration } from "owa-session-store";
import { APP_CONFIGS, BUSINESS_BASE_URL, CONSUMER_BASE_URL, HELP_DARK_THEME_ID, HELP_LIGHT_THEME_ID, } from "../constants/constants";

export function useHelpUrl(): string {
    const locale = getCurrentLanguage();
    const sessionId = getSessionId();
    const isDarkTheme = getIsDarkTheme();
    
    return React.useMemo(() => {
        const isMonarch = isGlobalFeatureEnabled("usv-nps-outlookDialog");
        const isConsumerUser = isConsumer();
        const config = isMonarch
            ? APP_CONFIGS.Monarch
            : isConsumerUser
                ? APP_CONFIGS.OwaConsumer
                : APP_CONFIGS.Owa;
        const sessionSettings = getUserConfiguration().SessionSettings;
        const baseUrl = isConsumerUser ? CONSUMER_BASE_URL : BUSINESS_BASE_URL;
        
        const queryParams: Record<string, string | number | boolean | undefined> = {
            NS: config.NS,
            locale,
            showNav: "true",
            Version: config.Version,
            omkt: locale,
            domain: window.location.hostname,
            origin: window.location.origin,
            feedback: "0",
            moveSupportCard: "0",
            isWebShell: "true",
            isConsumer: isConsumerUser.toString(),
            themeId: isDarkTheme ? HELP_DARK_THEME_ID : HELP_LIGHT_THEME_ID,
            sessionId,
            authType: isConsumerUser ? "MSA" : "AAD",
            userPuid: sessionSettings?.UserPuid,
        };
        
        const searchParams = new URLSearchParams();
        for (const [key, value] of Object.entries(queryParams)) {
            if (value !== undefined && value !== null) {
                searchParams.append(key, String(value));
            }
        }
        
        return `${baseUrl}/client/results?${searchParams.toString()}`;
    }, [locale, sessionId, isDarkTheme]);
}
